<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card>
          <v-card-title>Nouveau mot de passe</v-card-title>
          <v-card-text>
            <template v-if="!resetDone">
              <v-form v-model="isFormValid">
                <v-text-field
                  v-model="password"
                  label="Nouveau mot de passe*"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :rules="[v => !!v || 'Ce champ est nécessaire', v => (v && v.length >= 8) || 'Minimum 8 caractères']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="passwordConfirm"
                  label="Confirmer le mot de passe*"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock-check"
                  :rules="[v => !!v || 'Ce champ est nécessaire', v => v === password || 'Les mots de passe ne correspondent pas']"
                  required
                ></v-text-field>
              </v-form>
            </template>
            <template v-else>
              <v-alert type="success">
                Mot de passe modifié avec succès. Vous pouvez vous connecter.
              </v-alert>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="$router.push('/login')">Retour à la connexion</v-btn>
            <v-btn
              v-if="!resetDone"
              color="primary"
              :disabled="!isFormValid || isProcessing"
              :loading="isProcessing"
              @click="submit"
            >Valider</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ResetPasswordView",
  data() {
    return {
      password: "",
      passwordConfirm: "",
      showPassword: false,
      isFormValid: false,
      isProcessing: false,
      resetDone: false,
    };
  },
  methods: {
    async submit() {
      this.isProcessing = true;
      const token = this.$route.params.token;
      const result = await this.$store.dispatch("resetPassword", { token, password: this.password });
      this.isProcessing = false;
      if (result && result.success) {
        this.resetDone = true;
      }
    },
  },
};
</script>
